//LOGIN
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_USER = 'LOGOUT_USER';

//USER
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const SET_PROFILES = 'SET_PROFILES';
export const DELETE_USER = 'DELETE_USER';


//ALERT
export const CREATE_ALERT = 'CREATE_ALERT';

//LOADING
export const UPDATE_LOADING = 'UPDATE_LOADING';

//HOST
export const ADD_HOST = 'ADD_HOST';
export const UPDATE_HOST = 'UPDATE_HOST';
export const DELETE_HOST = 'DELETE_HOST';
export const SET_HOST = 'SET_HOST';
//KEYS
export const ADD_KEY = 'ADD_KEY';
export const UPDATE_KEY = 'UPDATE_KEY';
export const DELETE_KEY = 'DELETE_KEY';
export const SET_KEY = 'SET_KEY';

//LOG
export const DELETE_LOG = 'DELETE_LOG';
export const SET_LOG = 'SET_LOG';

//RC
export const ADD_RC = 'ADD_RC';
export const UPDATE_RC = 'UPDATE_RC';
export const DELETE_RC = 'DELETE_RC';
export const SET_RC = 'SET_RC';

//RULESBYAMOUNT
export const ADD_RULESBYAMOUNT = 'ADD_RULESBYAMOUNT';
export const UPDATE_RULESBYAMOUNT = 'UPDATE_RULESBYAMOUNT';
export const DELETE_RULESBYAMOUNT = 'DELETE_RULESBYAMOUNT';
export const SET_RULESBYAMOUNT = 'SET_RULESBYAMOUNT';

//TERMINAL
export const ADD_TERMINAL = 'ADD_TERMINAL';
export const UPDATE_TERMINAL = 'UPDATE_TERMINAL';
export const DELETE_TERMINAL = 'DELETE_TERMINAL';
export const SET_TERMINAL = 'SET_TERMINAL';

//TRANSACTION
export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';
export const SET_TRANSACTION = 'SET_TRANSACTION';

//PROTOCOLS
export const ADD_PROTOCOL = 'ADD_PROTOCOL';
export const UPDATE_PROTOCOL = 'UPDATE_PROTOCOL';
export const DELETE_PROTOCOL = 'DELETE_PROTOCOL';
export const SET_PROTOCOL = 'SET_PROTOCOL';